/* eslint-disable */
/** Registers an action to be called after a given method on an object. */
export const afterCalled = function (
  object: any,
  method: string,
  act: () => void
) {
  const fn = object[method];
  object[method] = function (msg: any) {
    fn.apply(this, [msg]);
    act();
  };
  /** Resets back to the original method (unsubscribe). */
  return function disposeAfterCalled() {
    object[method] = fn;
  };
};
